import { api } from "@/lib/api";

// --- Financial change requests (bank/UPI/PAN/GST) ---
export const createFinancialChange = (payload) =>
  api.post("/me/financial-changes", payload).then((r) => r.data);
export const listMyFinancialChanges = (params) =>
  api.get("/me/financial-changes", { params }).then((r) => r.data);
export const verifyFinancialOtp = (id, otp) =>
  api.post(`/me/financial-changes/${id}/verify-otp`, { otp }).then((r) => r.data);
export const cancelFinancialChange = (id) =>
  api.post(`/me/financial-changes/${id}/cancel`, {}).then((r) => r.data);

// Reusable KYC upload (existing endpoint) — returns { id, doc_type, status }
export const uploadKycAttachment = (file, doc_type = "other", note = "") => {
  const fd = new FormData();
  fd.append("file", file);
  fd.append("doc_type", doc_type);
  fd.append("note", note);
  return api
    .post("/lawyer/kyc/upload", fd, { headers: { "Content-Type": "multipart/form-data" } })
    .then((r) => r.data);
};
